/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TenantSeniorityStatusEnum } from './TenantSeniorityStatusEnum';
import {
    TenantSeniorityStatusEnumFromJSON,
    TenantSeniorityStatusEnumFromJSONTyped,
    TenantSeniorityStatusEnumToJSON,
    TenantSeniorityStatusEnumToJSONTyped,
} from './TenantSeniorityStatusEnum';

/**
 * 
 * @export
 * @interface ParcTenancyTenantDto
 */
export interface ParcTenancyTenantDto {
    /**
     * 
     * @type {string}
     * @memberof ParcTenancyTenantDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParcTenancyTenantDto
     */
    fullName: string;
    /**
     * 
     * @type {TenantSeniorityStatusEnum}
     * @memberof ParcTenancyTenantDto
     */
    seniorityStatus: TenantSeniorityStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ParcTenancyTenantDto
     */
    isValid: boolean;
    /**
     * Déclaration « à jour de ses loyers » (locataire en place) — null si jamais déclaré
     * @type {boolean}
     * @memberof ParcTenancyTenantDto
     */
    rentPaymentsUpToDate?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ParcTenancyTenantDto
     */
    rentToIncomeRatio?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParcTenancyTenantDto
     */
    hasGuarantor?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParcTenancyTenantDto
     */
    warnings?: Array<string>;
}



/**
 * Check if a given object implements the ParcTenancyTenantDto interface.
 */
export function instanceOfParcTenancyTenantDto(value: object): value is ParcTenancyTenantDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('seniorityStatus' in value) || value['seniorityStatus'] === undefined) return false;
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    return true;
}

export function ParcTenancyTenantDtoFromJSON(json: any): ParcTenancyTenantDto {
    return ParcTenancyTenantDtoFromJSONTyped(json, false);
}

export function ParcTenancyTenantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcTenancyTenantDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'],
        'seniorityStatus': TenantSeniorityStatusEnumFromJSON(json['seniorityStatus']),
        'isValid': json['isValid'],
        'rentPaymentsUpToDate': json['rentPaymentsUpToDate'] == null ? undefined : json['rentPaymentsUpToDate'],
        'rentToIncomeRatio': json['rentToIncomeRatio'] == null ? undefined : json['rentToIncomeRatio'],
        'hasGuarantor': json['hasGuarantor'] == null ? undefined : json['hasGuarantor'],
        'warnings': json['warnings'] == null ? undefined : json['warnings'],
    };
}

export function ParcTenancyTenantDtoToJSON(json: any): ParcTenancyTenantDto {
    return ParcTenancyTenantDtoToJSONTyped(json, false);
}

export function ParcTenancyTenantDtoToJSONTyped(value?: ParcTenancyTenantDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'seniorityStatus': TenantSeniorityStatusEnumToJSON(value['seniorityStatus']),
        'isValid': value['isValid'],
        'rentPaymentsUpToDate': value['rentPaymentsUpToDate'],
        'rentToIncomeRatio': value['rentToIncomeRatio'],
        'hasGuarantor': value['hasGuarantor'],
        'warnings': value['warnings'],
    };
}

